module.exports = __webpack_public_path__ + "img/9788949192208.ab53cd46.jpg";